import React from "react";
import RowCardItemState, { RowCardItemProps, RowItemRestrictions } from "./RowCardItem.models";
import './RowCardItem.scss';

export default class RowCardItem extends React.PureComponent<RowCardItemProps, RowCardItemState>{
    constructor(props: RowCardItemProps) {
        super(props);
        this.state = {};
    }

    render(): React.ReactNode {
        let { config, imageSource, title, subTitle } = this.props;
        return <>
            <div className="mb-2 box-shadow row-card-item-area">
                <div className="tk-inline card-boundel">
                    <div className="col-2 notspace">
                        <img src={imageSource} alt="row card icon"></img>
                    </div>
                    <div className="col-7 notspace" style={{ textAlign: "right", marginRight: "20px" }} >
                        <div className="pd-detail">
                            <div className={config?.titleExtraClass + " title tk-tooltip"}>
                                <label>{title !== undefined ? RowItemRestrictions(title, 15) : ''}</label>
                                <label className="tk-tooltiptext buttom">{title}</label>
                            </div>
                            <div className={config?.subTitleExtraClass + " sub-title"}>
                                <label>{subTitle !== null && subTitle !== undefined ? subTitle : ''}</label>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    }
}